import { CertGenParams } from '@yandex-int/k-common';

export const GLInfSpring2024 = ({
    school_name: schoolName,
    first_name: firstName,
    middle_name: middleName,
    last_name: lastName,
}: CertGenParams) => {
    return `<!doctype html>
    <html lang="ru" xmlns="http://www.w3.org/1999/html">
        <head>
            <meta charset="utf-8" />
            <meta name="description" content="" />
            <meta name="keywords" content="" />
            <meta name="viewport" content="width=device-width, maximum-scale=1.0, initial-scale=1.0" />
            <style type="text/css">
                /*
            //-----------------------------------------
            // Fonts
            //-----------------------------------------
            */

                @font-face {
                    font-family: 'YS Text';
                    src:
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-regular.woff') format('woff');
                    font-weight: 400;
                    font-style: normal;
                }

                @font-face {
                    font-family: 'YS Text';
                    src:
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff2') format('woff2'),
                        url('https://yastatic.net/s3/home/fonts/ys/1/text-medium.woff') format('woff');
                    font-weight: 500;
                    font-style: normal;
                }

                /*
            //-----------------------------------------
            // Print specifics
            // Игнорирует отключение фона при печати
            //-----------------------------------------
            */

                @page {
                    size: 210mm 297mm;
                    margin: 0;
                }

                @media print {
                    html,
                    body {
                        color-adjust: exact;
                        print-color-adjust: exact;
                        -webkit-print-color-adjust: exact;
                    }
                }

                /*
            //-----------------------------------------
            // Scaffolding
            //-----------------------------------------
            */

                html,
                body {
                    margin: 0;
                    padding: 0;
                    width: 100%;
                    height: 100%;
                }

                body {
                    font-size: calc(14 * 297mm / 895);
                    font-weight: 400;
                    font-family: 'YS Text';
                    line-height: calc(16 * 297mm / 895);
                    color: #000;
                    min-height: 100%;
                    height: 100%;
                    background: #ffffff;
                    -webkit-text-size-adjust: 100%;
                }

                * {
                    box-sizing: border-box;
                }

                /*
            //-----------------------------------------
            // Certificate
            //-----------------------------------------
            */

                .page {
                    position: relative;
                    width: 210mm;
                    height: 297mm;
                    overflow: hidden;
                    page-break-after: always;
                    break-after: page;
                    padding: calc(30 * 297mm / 895) calc(30 * 297mm / 895);

                    background-image: url('https://e7n.s3.yandex.net/static/certificates/GLInfWinter2024/bg.png');
                    background-repeat: no-repeat;
                    background-position: 0 0;
                    background-size: 100% 100%;
                }

                .logo {
                    width: calc(197 * 297mm / 895);
                    height: calc(24 * 297mm / 895);
                }

                .title {
                    font-size: calc(32 * 297mm / 895);
                    font-weight: 500;
                    line-height: calc(37.5 * 297mm / 895);

                    margin-top: calc(32 * 297mm / 895);
                    margin-bottom: calc(32 * 297mm / 895);
                }

                .info {
                    width: calc(325 * 297mm / 895);
                }

                .name {
                    font-size: calc(27 * 297mm / 895);
                    line-height: calc(32 * 297mm / 895);

                    margin-top: calc(52 * 297mm / 895);
                }

                .school {
                    font-size: calc(12 * 297mm / 895);
                    line-height: calc(16 * 297mm / 895);

                    margin-top: calc(12 * 297mm / 895);
                }

                .description {
                    font-size: calc(14 * 297mm / 895);
                    line-height: calc(16 * 297mm / 895);

                    margin-top: calc(32 * 297mm / 895);
                }

                .date {
                    position: absolute;
                    top: calc(39 * 297mm / 895);
                    left: calc(434 * 297mm / 895);

                    color: #fff;
                }

                .signature {
                    color: #fff;
                    position: absolute;
                    top: calc(305 * 297mm / 895);
                    left: calc(455 * 297mm / 895);
                }

                .signature__img {
                    width: calc(144 * 297mm / 895);
                }

                .signature__name {
                    font-size: 13pt;
                    line-height: 15pt;
                    letter-spacing: 0;
                    text-align: left;
                }

                .signature__position {
                    font-size: 10pt;
                    line-height: 14pt;
                    letter-spacing: 0;
                    text-align: left;

                    margin-top: calc(8 * 297mm / 895);
                }
            </style>
        </head>

        <body>
            <div class="page">
                <img
                    class="logo"
                    src="https://e7n.s3.yandex.net/static/cert-inf-2022-spring-olymp/logo.svg"
                    alt="Лого Яндекс"
                />
                <div class="info">
                    <div class="title">
                        Благодарственное<br />
                        письмо
                    </div>

                    <div class="name">
                        ${firstName ? `${firstName}` : ''} ${middleName ? `${middleName}` : ''}<br />
                        ${lastName ? `${lastName}` : ''}
                    </div>

                    <div class="school">${schoolName ? `${schoolName}` : ''}</div>

                    <div class="description">
                        Уважаемый учитель! <br />
                        Благодарим Вас за вклад в развитие<br />
                        олимпиадного движения и участие Ваших<br />
                        учеников в олимпиаде по информатике<br />
                        от Яндекс Учебника.
                    </div>
                </div>

                <div class="date">Москва, 2024</div>

                <div class="signature">
                    <img
                        class="signature__img"
                        src="https://e7n.s3.yandex.net/static/certificates/kraevskaya_white.png"
                        alt="подпись Краевской"
                    />
                    <div class="signature__name">Е.Б. Краевская</div>
                    <div class="signature__position">
                        Руководитель сервиса<br />
                        Яндекс Учебник
                    </div>
                </div>
            </div>
        </body>
    </html>
    `;
};
